"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _peractoUi = require("@peracto/peracto-ui");

var _InputRows = _interopRequireDefault(require("./InputRows"));

var _isArray = _interopRequireDefault(require("lodash/isArray"));

var _isObject = _interopRequireDefault(require("lodash/isObject"));

var _isString = _interopRequireDefault(require("lodash/isString"));

var _styled = require("./styled");

var _excluded = ["values", "readOnly"];

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var TextList = function TextList(_ref) {
  var values = _ref.values,
      help = _ref.help,
      label = _ref.label;
  var value = [];

  if ((0, _isString["default"])(values)) {
    value.push(values);
  } else if ((0, _isObject["default"])(values) && !(0, _isArray["default"])(values)) {
    for (var _i = 0, _Object$entries = Object.entries(values); _i < _Object$entries.length; _i++) {
      var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
          key = _Object$entries$_i[0],
          val = _Object$entries$_i[1];

      if (val) {
        value.push("".concat(key, ": ").concat(JSON.stringify(val)));
      }
    }
  } else {
    value = values;
  }

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, label && /*#__PURE__*/_react["default"].createElement("label", {
    className: "mb-1"
  }, label), help && /*#__PURE__*/_react["default"].createElement("p", {
    className: "help-text text-grey"
  }, help), value.length > 0 ? /*#__PURE__*/_react["default"].createElement(_styled.StyledList, null, value.map(function (item, idx) {
    return /*#__PURE__*/_react["default"].createElement("li", {
      key: "".concat(item, "_").concat(idx)
    }, item);
  })) : /*#__PURE__*/_react["default"].createElement("p", {
    className: "text-grey"
  }, "No values set for this field."));
};

var ConfigForm = function ConfigForm(_ref2) {
  var values = _ref2.values,
      readOnly = _ref2.readOnly,
      props = _objectWithoutProperties(_ref2, _excluded);

  return /*#__PURE__*/_react["default"].createElement(_peractoUi.Form, _extends({
    autoComplete: "off",
    values: values
  }, props), Object.keys(values.groups).map(function (group) {
    return /*#__PURE__*/_react["default"].createElement(_peractoUi.Group, {
      key: "".concat(values.groups[group].name, "-config"),
      id: "".concat(values.groups[group].name, "-config"),
      name: values.groups[group].name
    }, Object.keys(values.groups[group].values).map(function (val, idx) {
      var _value$input, _value$input3;

      var value = values.groups[group].values[val];
      var fieldName = "values[".concat(val, "]");
      var label = value.name;
      var isReadOnly = (value === null || value === void 0 ? void 0 : value.read_only) || readOnly;
      var input;
      var inputType = 'text';

      switch (value.data_type) {
        case 'rich_text':
          input = /*#__PURE__*/_react["default"].createElement(_peractoUi.RichText, {
            name: fieldName,
            label: label,
            help: value.description ? value.description : false,
            disabled: isReadOnly
          });
          break;

        case 'boolean':
          input = /*#__PURE__*/_react["default"].createElement(_peractoUi.Checkbox, {
            name: fieldName,
            label: label,
            help: value.description ? value.description : false,
            disabled: isReadOnly
          });
          break;

        case 'array':
          if ((value === null || value === void 0 ? void 0 : (_value$input = value.input) === null || _value$input === void 0 ? void 0 : _value$input.type) === 'input_rows') {
            var _value$input2;

            input = /*#__PURE__*/_react["default"].createElement(_InputRows["default"], {
              name: fieldName,
              label: label,
              description: value === null || value === void 0 ? void 0 : value.description,
              fields: value === null || value === void 0 ? void 0 : (_value$input2 = value.input) === null || _value$input2 === void 0 ? void 0 : _value$input2.fields
            });
          } else {
            if (isReadOnly) {
              input = /*#__PURE__*/_react["default"].createElement(TextList, {
                values: values === null || values === void 0 ? void 0 : values.values[val],
                label: label,
                help: value.description
              });
            } else {
              input = /*#__PURE__*/_react["default"].createElement(_peractoUi.Tags, {
                name: fieldName,
                label: label,
                options: value.input.options ? Object.values(value.input.options).map(function (opt) {
                  return {
                    label: opt,
                    value: opt
                  };
                }) : [],
                help: value.description ? value.description : false,
                disabled: isReadOnly
              });
            }
          }

          break;

        case 'int':
        case 'float':
          inputType = 'number';

        default:
          if (value !== null && value !== void 0 && (_value$input3 = value.input) !== null && _value$input3 !== void 0 && _value$input3.options) {
            // ...then it's a <select>
            if (isReadOnly) {
              input = /*#__PURE__*/_react["default"].createElement(TextList, {
                values: values === null || values === void 0 ? void 0 : values.values[val],
                label: label,
                help: value.description
              });
            } else {
              input = /*#__PURE__*/_react["default"].createElement(_peractoUi.Select, {
                name: fieldName,
                label: label,
                options: Object.values(value.input.options).map(function (opt) {
                  return {
                    label: opt,
                    value: opt
                  };
                }),
                help: value.description ? value.description : false,
                disabled: isReadOnly
              });
            }
          } else {
            if (isReadOnly) {
              input = /*#__PURE__*/_react["default"].createElement(TextList, {
                values: values === null || values === void 0 ? void 0 : values.values[val],
                label: label,
                help: value.description
              });
            } else {
              input = /*#__PURE__*/_react["default"].createElement(_peractoUi.Input, {
                name: fieldName,
                label: label,
                type: inputType,
                help: value.description ? value.description : false,
                disabled: isReadOnly
              });
            }
          }

      }

      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, {
        key: "".concat(group, ".").concat(val)
      }, input);
    }));
  }));
};

ConfigForm.propTypes = {
  values: _propTypes["default"].object.isRequired,
  schema: _propTypes["default"].object.isRequired,
  onSubmit: _propTypes["default"].func.isRequired
};
var _default = ConfigForm;
exports["default"] = _default;